var exports = {
  "M": "x7f9a0e16--8c89f0--page",
  "q": "x7f9a0e16--8c89f0--webview",
};

module.exports = exports;
